// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".featured-reviews__container[data-v-3350135e]{width:100%;padding:80px 16px;background-color:#25163a}.featured-reviews__content[data-v-3350135e]{margin:0 auto;width:100%;max-width:1120px;display:flex;flex-direction:column;gap:32px}.featured-reviews__heading[data-v-3350135e]{display:flex;flex-direction:row;align-items:center;gap:16px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
